import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppContext } from '../../Context/App/Provider';

const versionData = require('../../version.json')

export default function Header() {
  const { t } = useTranslation();
  const [{ version }, appDispatch] = useAppContext();

  if ( !version) {
    appDispatch( {version: versionData});
  }

  return (
    <div className="branding">
      <img src="/assets/images/logo.png" alt="Logo" />
      <span>
        {t('global.dashboard')}
        {(version && version.version) && (
          <span style={{ display: "grid", fontSize: "12px" }}>
            {t('global.version_letter')}
            {version.version}
          </span>
        )}
      </span>
    </div>
  );
}
